import React from 'react'
import PropTypes from 'prop-types'
import { makeStyles } from '@mui/styles'

import lang from '@/lang'

import SubnavigationItem, { propTypes as itemPropTypes } from './item'
import PerfectScrollbar from 'react-perfect-scrollbar'

const {
  settings: { jumpMarks },
} = lang

const useStyles = makeStyles((theme) => ({
  container: {
    width: 350,
    borderRight: theme.border,
    height: `calc(100vh - ${theme.pageContentOffset}px)`,
    overflow: 'auto',
    flexShrink: 0,
    background: theme.backgroundColor,
    '.layout.blank-heightAuto &': {
      height: '100vh',
    },
  },
}))

const Subnavigation = (props) => {
  const {
    items = [],
    children,
    customThresholdForObserver,
    refList,
  } = props
  const styles = useStyles()

  return (
    <div className={styles.container}>
      <PerfectScrollbar options={{ suppressScrollX: true }} className='forcePerfectScrollbarRight'>
        {items && items.map((item) => (
          <SubnavigationItem
            key={item.id}
            link={item.id}
            {...jumpMarks[item.id]}
            {...item}
            refList={refList}
            refItem={item}
            customThresholdForObserver={customThresholdForObserver}
          />
        ))}
        {children}
      </PerfectScrollbar>
    </div>
  )
}

export const propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape(itemPropTypes),
  ),
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.node),
  ]),
}
Subnavigation.propTypes = propTypes

export default Subnavigation
